export default __webpack_public_path__ + "static/media/mobile-BG.cbb9d3c4.webp";